import * as fromClientsAndAccounts from "@features/clients-and-accounts/store/clients-and-accounts.reducers";
import { ActionReducerMap } from "@ngrx/store";

import * as fromAuth from "../features/auth/store/auth.reducer";
import * as fromCompositionModel from "../features/composition-model-management/store/composition-model.reducers";
import * as fromCorporateActions from "../features/corporate-actions/store/corporate-actions.reducers";
import * as fromDashboard from "../features/dashboard/store/dashboard.reducer";
import * as fromManagement from "../features/management/store/management.reducers";
import * as fromMessage from "../features/messages/store/message.reducers";
import * as fromProduct from "../features/products/store/product.reducers";
import * as fromSystemTime from "../features/system-time/store/system-time.reducers";
import * as fromTrading from "../features/trading/store/trading.reducers";
import * as fromTransaction from "../features/transactions/store/transaction.reducers";

export interface AppState {
  auth: fromAuth.AuthState;
  dashboard: fromDashboard.DashboardState;
  management: fromManagement.ManagementState;
  trading: fromTrading.TradingState;
  product: fromProduct.ProductState;
  message: fromMessage.MessageState;
  clientsAndAccounts: fromClientsAndAccounts.ClientsAndAccountsState;
  transaction: fromTransaction.TransactionState;
  corporateActions: fromCorporateActions.CorporateActionsState;
  compositionModel: fromCompositionModel.CompositionModelState;
  systemTime: fromSystemTime.SystemTimeState;
}

export const APP_REDUCER: ActionReducerMap<AppState> = {
  auth: fromAuth.AUTH_REDUCER,
  dashboard: fromDashboard.DASHBOARD_REDUCER,
  management: fromManagement.MANAGEMENT_REDUCER,
  trading: fromTrading.TRADING_REDUCER,
  product: fromProduct.PRODUCT_REDUCER,
  message: fromMessage.MESSAGES_REDUCER,
  clientsAndAccounts: fromClientsAndAccounts.CLIENTS_AND_ACCOUNTS_REDUCER,
  transaction: fromTransaction.TRANSACTION_REDUCER,
  corporateActions: fromCorporateActions.CORPORATE_ACTIONS_REDUCER,
  compositionModel: fromCompositionModel.COMPOSITION_MODEL_REDUCER,
  systemTime: fromSystemTime.SYSTEM_TIME_REDUCER,
};
